import axios from 'axios';
import {PagePermission} from '../types';
import {APIResponse} from '../../../../types';

const LOGIN_URL = '/auth/login';
const LOGOUT_URL = '/auth/logout';
const REFRESH_URL = '/auth/refreshToken';
const GET_PERMISSIONS_URL = '/auth/getPermissions';

type LoginWithTokensResponse = APIResponse<{
  userID: number,
  adminPermissionsLevel: number,
  firmLogoUrl: string,
  greenInvoiceApiKey: string,
  greenInvoiceSecret: string,
  greenInvoicePaymentPluginID: string,
  pages: {
    is_default: 0 | 1
    page_name: string
    permission_level: 'full' | 'view' | 'block'
  }[],
}>

type RefreshTokenResponse = APIResponse<{
  newTokenData: {
    accessToken: string,
    expireTime: number
  }
}>

type UserPermissionsResponse = APIResponse<{
  permissions: PagePermission[]
}>

export function loginWithTokens(
  userEmail: string,
  accessToken: string,
  idToken: string,
  refreshToken: string,
  expire: number) {
  return axios.post<LoginWithTokensResponse>(
    LOGIN_URL,
    {
      userEmail,
      accessToken,
      idToken,
      refreshToken,
      expireTime: expire
    }
  );
}

export function logout() {
  return axios.post<void>(LOGOUT_URL, {});
}

export function refreshToken(accessToken: string) {
  return axios.post<RefreshTokenResponse>(REFRESH_URL, {}, {
    headers: {accessToken}
  });
}

export function getUserPermissions() {
  return axios.get<UserPermissionsResponse>(GET_PERMISSIONS_URL);
}

